// PageSkills Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageBase from '../page_base/page_base.jsx'
import InputTag from '../../form/input_tag/input_tag.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Acl from '../../../lib/acl.jsx'
import { ProfileIcon } from '../../../common/layout/menu_icons/profile.jsx'

class PageSkills extends PageBase {
  constructor (props) {
    super(props, 'user-skills', 'user-profile', 'user-skills')

    this.state = {
      isLoading: false,
      dataDate: null
    }

    this.data = {
      user: null,
      skills: []
    }
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    return <div className='page-skills'>{this._renderForm()}</div>
  }

  /* renderHeader() {
    return (
      <PageHeaderUser title="user.profile.title" pageIdent="user-skills"
        onChangePage={this._onChangePage.bind(this)} />
    );
  } */

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataUser(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataUser (callback) {
    app.debug('PageSkills: _getDataUser [start]')
    const findParams = {
      query: {
        userId: app.loggedInId,
        teamId: app.getTeamId()
      }
    }

    app
      .service('/api/users/team')
      .find(findParams)
      .then(result => {
        if (result && result.data && result.data.length > 0) {
          this.data.user = result.data[0]

          const skills = result.data[0].skills
          if (skills && skills.length > 0) {
            skills.map((skill, idx) => {
              this.data.skills.push({ id: idx + 1, text: skill.toLowerCase() })
            })
          }
          /* eslint standard/no-callback-literal: "off" */
          callback(null)
        } else {
          /* eslint standard/no-callback-literal: "off" */
          callback('Invalid user details')
        }
      })
      .catch(err => {
        app.debug('PageSkills: _getDataUser ERROR ', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (err) {
      app.debug('PageSkills: _onDataReceived Error', err)
    } else {
      app.debug('PageSkills: _onDataReceived [done]')
    }
    this.setState({ isLoading: false, dataDate: new Date() })
  }

  _renderForm () {
    return (
      <div className='userskill-form'>
        <div className='title'>
          <h2>
            <IntlMessage ident='user.skills.skillsFormTitle' />
          </h2>
        </div>
        <div className='content'>
          <InputTag
            placeholder='user.skills.addSkills'
            tags={this.data.skills}
            onUpdateTags={this._onUpdateSkills.bind(this)}
          />
        </div>
      </div>
    )
  }

  _onUpdateSkills (skills) {
    const skillsArr = []
    if (skills && skills.length > 0) {
      skills.map(skill => {
        skillsArr.push(skill.text)
      })
    }

    const params = {
      query: {
        $client: {
          skillTeamId: {
            id: app.getTeamId(),
            invite: false
          }
        }
      }
    }

    app
      .service('/api/users/team')
      .patch(this.data.user.id, { skills: skillsArr }, params)
      .then(_result => {
        this.data.skills = skillsArr
        this.setState({ dataDate: new Date() })
      })
      .catch(err => {
        app.debug('PageSkills: _onUpdateSkills Error', err)
      })
  }

  /* Header Functions - START */
  renderHeader () {
    const tabsUser = [
      {
        ident: 'user-profile',
        title: 'user.overview.overview',
        showFavourite: true
      },
      {
        ident: 'user-schedule',
        title: 'user.schedule.schedule',
        showFavourite: true
      },
      {
        ident: 'user-skills',
        title: 'user.skills.skills',
        showFavourite: true
      },
      {
        ident: 'personal-setting',
        title: 'user.personal.settings',
        showFavourite: true
      }
    ]

    const tabs = []

    tabsUser.map((tabitem, _idx) => {
      if (Acl.isPageAllowed(tabitem.ident)) {
        tabs.push(tabitem)
      }
    })

    return (
      <PageHeader
        title='user.profile.title'
        icon={<ProfileIcon width={20} />}
        activeTab='user-skills'
        favoriteTab={this._getUserFavoriteTab('user') || 'user-profile'}
        tabs={tabs}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('user', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions -END */
}

export default PageSkills
